import { axiosInstance } from '~/common/utils/api.util';

import type { PaginatedApiResponse } from '~/common/types/api.type';
import type { WolAgent, WolAgentListParams } from '~/features/wol-agent/types/wol-agent.type';

/**
 * WOL Agent 목록 조회
 * @endpoint GET /admin/wol-agents
 */
export function getWolAgentListApi(params?: WolAgentListParams) {
  return axiosInstance.get<PaginatedApiResponse<WolAgent>>('/admin/wol-agents', { params });
}
